/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandFramerMotion = createReactComponent("outline", "brand-framer-motion", "IconBrandFramerMotion", [["path", { "d": "M12 12l-8 -8v16l16 -16v16l-4 -4", "key": "svg-0" }], ["path", { "d": "M20 12l-8 8l-4 -4", "key": "svg-1" }]]);

export { IconBrandFramerMotion as default };
//# sourceMappingURL=IconBrandFramerMotion.mjs.map
